module.exports = __webpack_public_path__ + "beautifulwebsite.svg?6e52b66964d4788e6d7fbe0d353fedb6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/icons/beautifulwebsite.svg
// module id = 143
// module chunks = 0